import React from 'react';
import PropTypes from 'prop-types';
import { PageSidebar } from './page-sidebar';
import Heading from '@mapbox/mr-ui/heading';

class PageWrapper extends React.Component {
  renderSidebar() {
    const { sidebarSections } = this.props;

    if (!sidebarSections) {
      return null;
    }

    return (
      <div className="col col--12 col--4-ml mb24">
        <PageSidebar sections={sidebarSections} />
      </div>
    );
  }

  render() {
    const { sectionName, children } = this.props;
    return (
      <div
        className="flex-parent flex-parent--column"
        style={{ minHeight: '100vh' }}
      >
        <div className="flex-child">
          <div className="limiter mb36">
            <div className="grid">
              <h2 className="mb12">
                <Heading variant="primary">{sectionName}</Heading>
              </h2>
            </div>
          </div>
        </div>
        <div className="flex-child flex-child--grow relative z0">
          <div className="limiter">
            <div className="grid grid--gut36 grid--gut60-mm grid--gut120-mxl flex-parent--row-ml flex-parent--column-reverse">
              <div className="col col--12 col--8-ml">{children}</div>
              {this.renderSidebar()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PageWrapper.propTypes = {
  sectionName: PropTypes.string,
  sectionNames: PropTypes.array
};

export { PageWrapper };
